import React from 'react';
import Sidebar from '../Sidebar';
import { Box, Flex, FlexProps } from 'rebass';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { SIDEBAR_COLLAPSED_WIDTH } from '@/components/Sidebar/Sidebar';

export const MainColumn = (props: FlexProps): JSX.Element => (
  <Flex
    as="main"
    bg="background"
    color="text"
    flexDirection="column"
    maxWidth="100%"
    height="100%"
    overflow="auto"
    flexGrow={1}
    flexShrink={1}
    {...(props as any)}
  />
);

type ThirdPaneWrapperProps = {
  paneVisible?: boolean;
  // paneWidth?: number;
};

const ThirdPaneWrapper = styled(Box)<ThirdPaneWrapperProps>`
  position: relative;
  overflow: hidden;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;

  main {
    background: linear-gradient(0deg, #fff, #fafafa, #f1f1f1);
    display: flex;
    flex-direction: column;
  }

  .third-pane {
    transition: transform 0.3s ease;
  }

  .third-pane-toggle {
    transition-delay: 0.3s;
    opacity: ${(props) => (props.paneVisible ? '1' : '0')};
    transform: ${(props) =>
      props.paneVisible ? 'translateX(0)' : 'translateX(100%)'};
  }
`;

type LayoutProps = {
  children?: React.ReactNode;
  paneVisible?: boolean;
};

/**
 * @component for page layout
 */
const ThirdPaneLayout = (props: LayoutProps): JSX.Element => {
  return (
    <Flex sx={{ height: '100vh', overflow: 'hidden' }}>
      <Sidebar />
      <ThirdPaneWrapper
        paneVisible={props.paneVisible}
        sx={{
          ml: [SIDEBAR_COLLAPSED_WIDTH, SIDEBAR_COLLAPSED_WIDTH, 0],
        }}
      >
        {props.children}
      </ThirdPaneWrapper>
    </Flex>
  );
};

ThirdPaneLayout.propTypes = {
  children: PropTypes.node,
};

export default ThirdPaneLayout;
